module.exports = __webpack_public_path__ + "carousel7.47965ba2.jpg";